<template>
  <confirmation-dialog
    confirm-text="Отправить"
    :disabled="props.disabled || isAnyResourceEdit"
    :action="sendToModeration"
  >
    <template #activator>
      <e-btn variant="primary" :disabled="props.disabled || isAnyResourceEdit">Отправить на модерацию</e-btn>
    </template>

    <div class="h3 mb-6">Отправка тарифного плана на модерацию</div>
    <p class="paragraph-l text-secondary">
      После отправки тарифного плана на модерацию вы не сможете редактировать <b>Общую информацию</b> и
      <b>Группы услуг</b>
    </p>
  </confirmation-dialog>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';
import { EBtn } from '@/core/components/ui';
import { useCommonLockResourceStore } from '@/core/composables/useLockResource';
import { useServiceGroupsStore } from '@/parts/tariffs/store/serviceGroups';
import { useTariffsStore } from '@/parts/tariffs/store/tariffs';

const props = defineProps<{
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (event: 'error', errorType: string): void;
  (event: 'success'): void;
}>();

const { isAnyResourceEdit } = useCommonLockResourceStore();
const $route = useRoute();

const { sendTariffToModeration } = useTariffsStore();
const { setDisabledOperations } = useServiceGroupsStore();

const sendToModeration = async () => {
  const result = await sendTariffToModeration(String($route.params.t_id));

  if (result?.errors) {
    emit('error', result?.errors[0].__typename);
  } else {
    emit('success');
    setDisabledOperations();
  }
};
</script>

<style scoped lang="scss"></style>
